<script setup lang="ts">
import { relativeWindow } from './ranking-contract.mjs'
const props = defineProps<{ windowEnd?: number }>()
const { t, locale } = useI18n()
const now = useState('ranking-clock', () => Date.now())
let timer: ReturnType<typeof setInterval> | undefined
onMounted(() => { now.value = Date.now(); timer = setInterval(() => { now.value = Date.now() }, 60000) })
onBeforeUnmount(() => clearInterval(timer))
</script>
<template><time v-if="windowEnd && windowEnd > 0" :datetime="new Date(windowEnd).toISOString()" class="ranking-updated">{{ t('mm.explore.updated', { time: relativeWindow(windowEnd, locale, now) }) }}</time></template>
<style scoped>.ranking-updated { display: block; color: var(--text-2); font: 500 var(--t-micro)/1.5 var(--font-mono); margin-block: var(--s-2); }</style>
